/**
 * https://github.com/gnea/grbl/wiki/Grbl-v1.1-Interface#real-time-status-reports
 * Example: <Idle|MPos:0.000,0.000,0.000|FS:0,0|WCO:0.000,0.000,0.000>
 * @param message
 * @returns
 */
export function parseGrblStatus(message) {
    const parameters = message.slice(0, -1).split("|");
    const status = {
        type: "status",
        machine_state: parameters[0],
        sub_state: parameters[0].split(":")[1],
    };
    parameters.slice(1).forEach(str => {
        const [key, valueStr] = str.split(":");
        if (grblStatusKeys.has(key)) {
            const parse = grblStatusParsers[key];
            parse(status, valueStr);
        }
    });
    // Calculate MPos from WPos and WCO
    if (status.work_position && status.work_coordinate_offset) {
        status.machine_position = {
            x: status.work_position.x + status.work_coordinate_offset.x,
            y: status.work_position.y + status.work_coordinate_offset.z,
            z: status.work_position.z + status.work_coordinate_offset.z,
        };
    }
    // Calculate WPos from MPos and WCO
    else if (status.machine_position && status.work_coordinate_offset) {
        status.work_position = {
            x: status.machine_position.x - status.work_coordinate_offset.x,
            y: status.machine_position.y - status.work_coordinate_offset.z,
            z: status.machine_position.z - status.work_coordinate_offset.z,
        };
    }
    return status;
}
/**
 * A bunch of functions to parse the status parameters from the status response.
 * They modify the status object depending on the parameter being parsed.
 */
const grblStatusParsers = {
    "MPos": (status, s) => status.machine_position = stringToVector3(s),
    "WPos": (status, s) => status.work_position = stringToVector3(s),
    "F": (status, s) => status.feed = Number(s),
    "FS": (status, s) => { const [feed, speed] = s.split(",").map(s => Number(s)); status.feed = feed; status.speed = speed; },
    "WCO": (status, s) => status.work_coordinate_offset = stringToVector3(s),
    "Bf": (status, s) => status.buffer_state = s.split(",").map(s => Number(s)),
    "Ln": (status, s) => status.line_number = Number(s),
    "Pn": (status, s) => status.pin_state = s.split(""),
    "Ov": (status, s) => status.override_values = s.split(",").map(s => Number(s)),
    "A": (status, s) => status.accessory_state = s.split(""),
};
const grblStatusKeys = new Set(Object.keys(grblStatusParsers));
function stringToVector3(str) {
    const [x, y, z] = str.split(",").map(s => Number(s));
    return { x, y, z };
}
